import { RecruiterDashboardWidgets } from '@/features/recruiter/components/RecruiterDashboardWidgets'
import { UserType } from '@/constants/roles'
import { useAuthStore } from '@/store/authStore'

export function DashboardPage() {
  const user = useAuthStore((s) => s.user)
  const isRecruiter =
    user?.userType === UserType.RecruiterUser || user?.userType === UserType.RecruiterAdmin

  return (
    <>
      {!isRecruiter && (
        <div className="d-flex align-items-center justify-content-between my-4 page-header-breadcrumb flex-wrap gap-2">
          <div>
            <p className="fw-semibold fs-20 mb-0">Welcome back{user ? `, ${user.name}` : ''}</p>
            <p className="fs-13 text-muted mb-0">Here's what's happening with your account.</p>
          </div>
        </div>
      )}

      {isRecruiter ? (
        <RecruiterDashboardWidgets />
      ) : (
        <div className="row">
          <div className="col-xl-12">
            <div className="card custom-card">
              <div className="card-body">
                <p className="mb-0">
                  Your profile and application tools will appear here as they become available.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
